"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Orbus Artwork Uploader
 * Artwork uploader, PDF preflight queue & processor.  Please refer to the [AWS Developer Guide](https://docs.aws.amazon.com/AmazonS3/latest/dev/UsingRESTAPImpUpload.html) for multipart uploads.  The upload-related methods do not take file data themselves, rather they act as helper methods for using the AWS S3 APIs.  It is strongly recommended that you use Uppy and its [AWS S3 Multipart plugin](https://uppy.io/docs/aws-s3-multipart/) to assist with uploading files. The provided demo/example code offers a functioning example.
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 * no description
 */
class UploadApi extends runtime.BaseAPI {
    /**
     * Abort an upload in-progress
     */
    abortUploadRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.AbortUploadDTO === null || requestParameters.AbortUploadDTO === undefined) {
                throw new runtime.RequiredError('AbortUploadDTO', 'Required parameter requestParameters.AbortUploadDTO was null or undefined when calling abortUpload.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/upload/abort-upload`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.AbortUploadDTOToJSON(requestParameters.AbortUploadDTO),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Abort an upload in-progress
     */
    abortUpload(AbortUploadDTO) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.abortUploadRaw({ AbortUploadDTO: AbortUploadDTO });
        });
    }
    /**
     * Complete an upload
     */
    completeUploadRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.CompleteUploadDTO === null || requestParameters.CompleteUploadDTO === undefined) {
                throw new runtime.RequiredError('CompleteUploadDTO', 'Required parameter requestParameters.CompleteUploadDTO was null or undefined when calling completeUpload.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/upload/complete-upload`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.CompleteUploadDTOToJSON(requestParameters.CompleteUploadDTO),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.CompleteUploadResponseFromJSON(jsonValue));
        });
    }
    /**
     * Complete an upload
     */
    completeUpload(CompleteUploadDTO) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.completeUploadRaw({ CompleteUploadDTO: CompleteUploadDTO });
            return yield response.value();
        });
    }
    /**
     * Start a new multipart upload.
     */
    createUploadRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.CreateUploadBody === null || requestParameters.CreateUploadBody === undefined) {
                throw new runtime.RequiredError('CreateUploadBody', 'Required parameter requestParameters.CreateUploadBody was null or undefined when calling createUpload.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/upload/create-upload`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.CreateUploadBodyToJSON(requestParameters.CreateUploadBody),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.CreateUploadResponseFromJSON(jsonValue));
        });
    }
    /**
     * Start a new multipart upload.
     */
    createUpload(CreateUploadBody) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createUploadRaw({ CreateUploadBody: CreateUploadBody });
            return yield response.value();
        });
    }
    /**
     * Recursively delete a job\'s key(directory) and its contents from the finalized s3 bucket.
     */
    deleteJobFromBucketRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.DeleteJobDTO === null || requestParameters.DeleteJobDTO === undefined) {
                throw new runtime.RequiredError('DeleteJobDTO', 'Required parameter requestParameters.DeleteJobDTO was null or undefined when calling deleteJobFromBucket.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/upload/delete-job`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.DeleteJobDTOToJSON(requestParameters.DeleteJobDTO),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Recursively delete a job\'s key(directory) and its contents from the finalized s3 bucket.
     */
    deleteJobFromBucket(DeleteJobDTO) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteJobFromBucketRaw({ DeleteJobDTO: DeleteJobDTO });
        });
    }
    /**
     * List completed parts of a multipart upload.
     */
    listPartsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.ListPartsDTO === null || requestParameters.ListPartsDTO === undefined) {
                throw new runtime.RequiredError('ListPartsDTO', 'Required parameter requestParameters.ListPartsDTO was null or undefined when calling listParts.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/upload/list-parts`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ListPartsDTOToJSON(requestParameters.ListPartsDTO),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.ListPartsResponsePartFromJSON));
        });
    }
    /**
     * List completed parts of a multipart upload.
     */
    listParts(ListPartsDTO) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listPartsRaw({ ListPartsDTO: ListPartsDTO });
            return yield response.value();
        });
    }
    /**
     * List available preflight profiles
     */
    listProfilesRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/upload/list-profiles`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * List available preflight profiles
     */
    listProfiles() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listProfilesRaw();
            return yield response.value();
        });
    }
    /**
     * Process a file that already exists on S3.
     */
    processFileRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.ProcessFileDTO === null || requestParameters.ProcessFileDTO === undefined) {
                throw new runtime.RequiredError('ProcessFileDTO', 'Required parameter requestParameters.ProcessFileDTO was null or undefined when calling processFile.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/upload/process`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ProcessFileDTOToJSON(requestParameters.ProcessFileDTO),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Process a file that already exists on S3.
     */
    processFile(ProcessFileDTO) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.processFileRaw({ ProcessFileDTO: ProcessFileDTO });
        });
    }
    /**
     * Get a presigned url for an upload\'s part
     */
    signPartRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.SignPartDTO === null || requestParameters.SignPartDTO === undefined) {
                throw new runtime.RequiredError('SignPartDTO', 'Required parameter requestParameters.SignPartDTO was null or undefined when calling signPart.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/upload/sign-part`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.SignPartDTOToJSON(requestParameters.SignPartDTO),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.SignPartResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get a presigned url for an upload\'s part
     */
    signPart(SignPartDTO) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.signPartRaw({ SignPartDTO: SignPartDTO });
            return yield response.value();
        });
    }
}
exports.UploadApi = UploadApi;
